import { For, type JSX, type Component } from "solid-js";
import type { SimpleDropdownConfig, NavLink } from "../navbarConfig";
import { classNames } from "@core/lib/classNames";
import styles from "./Navbar.module.css";
// HoverCard import is not needed here as the parent Navbar.tsx handles HoverCard.Content
// import { HoverCard } from "@kobalte/core";

interface ResourcesDropdownProps {
  config: SimpleDropdownConfig;
  // Props like isOpen, onClose, id, triggerRef might not be needed
}

// Renamed to Content and simplified
export const ResourcesDropdownContent: Component<ResourcesDropdownProps> = (props) => {
  return (
    // Parent Navbar.tsx wraps this in HoverCard.Content with styles["header-hover-card-resources"]
    // This component now renders the links directly into that parent container.
    // Using the same wrapper class as UseCasesDropdownContent for consistency.
    <div class={styles["dropdown-link-wrap"]}>
      <For each={props.config.links}>
        {(link: NavLink) => (
          // Using the same link class as UseCasesDropdownContent
          <a href={link.href} class={styles["header-hover-card-content-column-link"]}>
            <span>{link.label}</span>
          </a>
        )}
      </For>
    </div>
  );
};

// Removed default export
